
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.542 6.828l-1.414-1.414-7.906 7.906.04 1.375 1.374.04 7.906-7.907zM9.01 16.746l-2.75-.08a1 1 0 01-.97-.97l-.08-2.75a1 1 0 01.293-.735l8.918-8.918a1 1 0 011.414 0l2.829 2.828a1 1 0 010 1.415l-8.918 8.918a1 1 0 01-.736.292zM3 20.063v-2h18v2H3z"}})])
          )
        }
      }
    